<template lang="pug">
div(style='padding-top: 20px')
    span.titulo-informacao {{ $t('mensagens.territorio.informacao.titulo') }}
    <br/>
    el-row.tabela(:gutter='24')
        el-col(:span='7')
            span.tituloColuna {{ $t('mensagens.territorio.informacao.colheita') }}
        el-col(:span='1')
            span.tituloColuna {{ $t('mensagens.territorio.informacao.adicionar') }}
        el-col(:span='24', style='padding: 0')
            div(v-for='(informacao, index) in informacoes' class="informacao-item")
                el-form(:model='informacao', :ref='"formCom" + index')
                    el-col(:span='7')
                        el-form-item.margin(prop='cultura')
                        el-select(
                            v-model='informacao.cultura.id',
                            :placeholder="$t('mensagens.comuns.selecione')",
                            style='width: 100%',
                            @change='atualizar()'
                        )
                            el-option(
                                v-for='col in colheitas',
                                :key='col.id',
                                :label='col.nome',
                                :value='col.id'
                            )
                    el-col(:span='1' :class="{ 'pl-4': index === 0, 'pl-1': index > 0 }")
                        .block-informacao
                            i.el-icon-delete.icon(
                                v-if="index > 0"
                                :popup="$t('mensagens.comuns.remover')",
                                @click='openModalRemover(index)',
                                style='color: #900000'
                            )
                            i.el-icon-circle-plus-outline.icon-plus(
                                :popup="$t('mensagens.comuns.adicionar')",
                                @click='addCom()'
                            )
    #modal-delete-informacao-are-you-sure.row(
        v-if='deleteInformacaoModal'
    )
        el-dialog(:visible.sync='deleteInformacaoModal', width='500px')
            span(slot='title')
                h1.mb-2.font-weight-bold(
                    style='text-align: left; font-size: 18px'
                ) {{ $t('mensagens.territorio.informacao.removerInformacao') }}
            .column.d-flex.justify-content-center.align-items-center.flex-column
                h2.mb16 {{ $t('mensagens.territorio.informacao.temCertezaqueDesejaRemoverRegistro') }}
                .buttons-modal.mb16
                    el-button(size='mini', @click='closeModalRemover')
                        | {{ $t('mensagens.comuns.cancelar') }}
                    el-button(
                        type='primary',
                        size='mini',
                        @click='deleteInformacao'
                    )
                        | {{ $t('mensagens.comuns.remover') }}
</template>

<script>
import culturaService from '@/services/CulturaService';

export default {
    name: 'InformacaoAgricola',

    props: {
        informacaoSelected: {
            type: Array,
            required: false
        }
    },

    data() {
        return {
            colheitas: [],
            informacoes: [
                {
                    cultura: {
                        id: ''
                    },
                    idCultura: null
                }
            ],
            deleteInformacaoModal: false,
            indexRemover: null
        };
    },

    mounted() {
        this.buscaColheitas();

        if (
            this.informacaoSelected &&
            this.informacaoSelected.length > 0
        ) {
            this.informacoes = this.informacaoSelected;
        }
    },
    methods: {
        async buscaColheitas() {
            await culturaService.findCultura().then(({ data }) => {
                this.colheitas = data;
            });
        },

        openModalRemover(index) {
            this.indexRemover = index;
            this.deleteInformacaoModal = true;
        },

        closeModalRemover() {
            this.deleteInformacaoModal = false;
        },

        deleteInformacao() {
            if (this.indexRemover != null) {
                this.informacoes.splice(this.indexRemover, 1);
                if (
                    this.indexRemover === 0 &&
                    this.informacoes.length === 0
                ) {
                    this.addCom();
                }
                this.indexRemover = null;
                this.deleteInformacaoModal = false;
                this.atualizar();
            }
        },

        addCom() {
            this.informacoes.push({
                cultura: {
                    id: ''
                },
                idCultura: null
            });
            this.atualizar();
        },

        atualizar() {
            // this.informacoes.idCultura = this.informacoes.cultura.id;
            this.$bus.$emit('informacoes', this.informacoes);
        }
    }
};
</script>

<style lang="scss">
.titulo-informacao {
    font-size: 14px;
    color: var(--primary);
    font-weight: bold;
}
.tituloColuna {
    font-size: 13px;
    color: #19194b;
}

.tabela {
    width: 100%;
    padding-top: 15px;
    padding-bottom: 10px;
}
.icon {
    font-size: 20px;
    cursor: pointer;
    padding-top: 10px;
    padding-left: 8px;
    color: #19194b;
}

.icon-plus {
    cursor: pointer;
    margin: 10px 0 0 6px;
    font-size: 12px;
    color: white;
    width: 26px;
    height: 26px;
    background-color: green;
    padding: 7px;
    border-radius: 2px;
}
.margin {
    margin-bottom: 12px;
}

.mb16 {
    margin-bottom: 16px;
}
.buttons-modal {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
}
#modal-delete-informacao-are-you-sure {
    text-align: center;
}
.block-informacao {
    display: flex;
    align-items: center;
}
.informacao-item {
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
}
</style>
